export default __webpack_public_path__ + "static/media/analysis.08f5c615.svg";